export default "__VITE_ASSET__CMAXU901__"